var exports = {
  "x": "xa15a2ab7--348d2e--button",
  "v": "xa15a2ab7--348d2e--no-margin-top",
};

module.exports = exports;
